import styled from 'styled-components'

export const ButtonContainer = styled.div`
  margin: -20px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/app/modules/AddressFormOtherSection/styles.js